var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    y: 0.458008,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBFFF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8122 7.79138C15.6288 7.79138 8.14551 15.2747 8.14551 24.458C8.14551 33.6414 15.6288 41.1247 24.8122 41.1247C33.9955 41.1247 41.4788 33.6414 41.4788 24.458C41.4788 15.2747 33.9955 7.79138 24.8122 7.79138ZM32.7788 20.6247L23.3288 30.0747C23.0955 30.308 22.7788 30.4414 22.4455 30.4414C22.1122 30.4414 21.7955 30.308 21.5622 30.0747L16.8455 25.358C16.3622 24.8747 16.3622 24.0747 16.8455 23.5914C17.3288 23.108 18.1288 23.108 18.6122 23.5914L22.4455 27.4247L31.0122 18.858C31.4955 18.3747 32.2955 18.3747 32.7788 18.858C33.2622 19.3414 33.2622 20.1247 32.7788 20.6247Z",
    fill: "#0C865D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.01b488553a520756f2adf2ec15a05d1e.svg";
export { ForwardRef as ReactComponent };